<template>
  <table>
    <!-- 表格标题 -->
    <tr class="title" v-if="config.type !== 'training'">
      <td>时间</td>
      <td :colspan="config.table.tableWidth">日程</td>
    </tr>

    <!-- before -->
    <tr
      v-for='(sch, time) in schsCommon'
      v-if="config.type !== 'training' && checkTime(time, config.date, 'am')" :key="time">
      <td class="time-td">{{ getTimeV2(sch.beginTime)}}-{{ getTimeV2(sch.endTime)}}</td>
      <td :colspan="config.table.tableWidth" v-html="sch.title"></td>
    </tr>

    <!-- training -->
    <template v-if="config.type === 'training'">
    <!-- 主题 -->
    <tr class="title topic">
      <td rowspan="2">时间</td>
      <td
        v-for="(item, index) in config.table.topic"
        v-if="topics[item.topicId]"
        :colspan="item.width"
        :class="Number(topics[item.topicId].type) === 2 ? 'manufacturers-build':'' " :key="index">
        <router-link :to="'/track/' + item.topicId" class="topic-name-link topic-name">
          {{ topics[item.topicId].topic }} <br/>
        </router-link>
        <template v-if="topics[item.topicId].producerIds[0]">
        <router-link
          v-if="topics[item.topicId].producerIds[0] && speakers[topics[item.topicId].producerIds[0]]"
          :to="'/track/' + item.topicId"
          class="producter-link">
          <span v-for="(speaker, key) in topics[item.topicId].speakers" :key="key">{{ speaker.name }}</span>
          出品
          <!--{{ speakers[topics[item.topicId].producerIds[0]].name }} 出品-->
        </router-link>
        </template>
      </td>
    </tr>
    <!-- 地址 -->
    <tr class="address">
      <td
        v-for="(item, idx) in config.table.topic"
        :key="idx"
        v-if="topics[item.topicId]"
        :colspan="item.width"
        :class="Number(topics[item.topicId].type) === 2 ? 'manufacturers-build':'' ">
        <p v-if="topics[item.topicId].address">
          {{ topics[item.topicId].address }}
        </p>
      </td>
    </tr>
    <!-- 培训议题 -->
    <!-- v-if="topics[lectures.topicId] && Number(topics[lectures.topicId].typeid) !== 3" -->
    <tbody
      v-for='(lectures, id) in schsTraining'
      :key="id"
      class="subject">
      <tr>
        <td class="time-td">
          {{ getTimeTraining(lectures.beginTime, lectures.endTime).day }}
          <br>
          {{ getTimeTraining(lectures.beginTime, lectures.endTime).zone }}
        </td>
        <td
          v-for='(item, idx) in config.table.topic'
          :key="idx"
          :colspan="item.width"
          :class="{
            overseas:lectures[item.topicId] && lectures[item.topicId].isOversea,
            'no-presentation': !lectures[item.topicId]
          }">
          <template v-if="lectures[item.topicId]">
            <router-link :to="'/training/' + lectures[item.topicId]['id']">
              <!-- <span class="overseas" v-if="lectures[item.topicId].isOversea">【海外】</span> -->
              {{ lectures[item.topicId]['title'] }}
            </router-link>
          <template v-if="lectures[item.topicId].speakers">
            <p class="postion" v-for="(speaker, idx) in lectures[item.topicId].speakers" :key="idx">
              {{ speaker.name }}
              <span>{{ speaker.company }}</span>
              <span v-if="speaker.position"> /</span>
              <span v-html="speaker.position"></span>
            </p>
            </template>
            <!-- 图标 -->
            <img class="overseas-img" src="./assets/overseas.svg" v-if="lectures[item.topicId].isOversea">
            <p class="sch-icons">
              <a class="iconfont icon-video" v-if="lectures[item.topicId].videoLink" :href="lectures[item.topicId].videoLink" target="_blank">
                <!-- <img src="./assets/video_icon.svg"> -->
              </a>
              <span v-if="!Boolean(lectures[item.topicId].videoStatus)">
                <img src="./assets/video_forbidden.svg">
              </span>
              <a class="iconfont icon-ppt" v-if="Number(lectures[item.topicId].pptStatus)===0&&lectures[item.topicId].pptLink" :href="lectures[item.topicId].pptLink" target="_blank">
                <!-- <img src="./assets/ppt_icon.svg"> -->
              </a>
              <span v-if="Number(lectures[item.topicId].pptStatus)===1">
                <img src="./assets/ppt_forbidden.svg">
              </span>
              <a class="iconfont icon-live_icon" v-if="lectures[item.topicId].hasLive" href="https://time.geekbang.org/">
                <!-- <img src="./assets/live_icon.svg"> -->
              </a>
              <span class="iconfont icon-ppt_inreview" v-if="Number(lectures[item.topicId].pptStatus)===2">
                <!-- <img src="./assets/ppt_inreview.svg"> -->
              </span>
            </p>
          </template>
          <template v-else>
            <p class="postion">
              <span>/</span>
            </p>
          </template>
        </td>
      </tr>
    </tbody>
    </template>

    <!-- am -->
    <template v-if="config.type !== 'training'">
    <!-- 主题 -->
    <tr class="title topic" v-if="config.table.amTopic">
      <td rowspan="2">上午</td>
      <td
        v-for="(item,idx) in config.table.amTopic"
        :key="idx"
        v-if="topics[item.topicId]"
        :colspan="item.width"
        :class="Number(topics[item.topicId].type) === 2 ? 'manufacturers-build':'' ">
        <router-link :to="'/track/' + item.topicId" class="topic-name-link topic-name">
          {{ topics[item.topicId].topic }} <br/>
        </router-link>
        <template v-if="topics[item.topicId].producerIds[0]">
        <router-link
          v-if="topics[item.topicId].producerIds[0] && speakers[topics[item.topicId].producerIds[0]]"
          :to="'/track/' + item.topicId"
          class="producter-link">
          <span v-for="(speaker, key) in topics[item.topicId].speakers" :key="key">{{ speaker.name }}</span>
          出品
          <!--{{ speakers[topics[item.topicId].producerIds[0]].name }} 出品-->
        </router-link>
        </template>
      </td>
    </tr>
    <!-- 地址 -->
    <tr class="address">
      <td
        v-for="(item, idx) in config.table.amTopic"
        :key="idx"
        v-if="topics[item.topicId]"
        :colspan="item.width"
        :class="Number(topics[item.topicId].type) === 2 ? 'manufacturers-build':'' ">
        <p v-if="topics[item.topicId].address">
          {{ topics[item.topicId].address }}
        </p>
      </td>
    </tr>
    <!-- 议题 -->
    <tbody
      v-for='(lectures, time) in schedules'
      :key="time"
      v-if="checkTime(time, config.date, 'am')"
      class="subject">
      <tr>
        <td class="time-td">{{ getTimeV2(lectures.beginTime)}}-{{ getTimeV2(lectures.endTime)}}</td>
        <td
          v-for='(item, idx) in config.table.amTopic'
          :key="idx"
          :colspan="item.width"
          :class="{
            overseas:lectures[item.topicId] && lectures[item.topicId].isOversea,
            'no-presentation': !lectures[item.topicId]
          }">
          <template v-if="lectures[item.topicId]">

            <router-link :to="'/presentation/' + lectures[item.topicId]['id']">
              <!-- <span class="overseas" v-if="lectures[item.topicId].isOversea">【海外】</span> -->
              {{ lectures[item.topicId]['title'] }}
            </router-link>
          <template v-if="lectures[item.topicId].speakers">
            <p class="postion" v-for="(speaker, idx) in lectures[item.topicId].speakers" :key="idx">
              {{ speaker.name }}
              <span>{{ speaker.company }}</span>
              <span v-if="speaker.position"> /</span>
              <span v-html="speaker.position"></span>
            </p>
          </template>
            <!-- 图标 -->
            <img class="overseas-img" src="./assets/overseas.svg" v-if="lectures[item.topicId].isOversea">
            <p class="sch-icons">
              <a class="iconfont icon-video" v-if="lectures[item.topicId].videoLink" :href="lectures[item.topicId].videoLink" target="_blank">
                <!-- <img src="./assets/video_icon.svg"> -->
              </a>
              <a v-if="!lectures[item.topicId].videoStatus">
                <img src="./assets/video_forbidden.svg">
              </a>
              <a class="iconfont icon-ppt" v-if="Number(lectures[item.topicId].pptStatus)===0&&lectures[item.topicId].pptLink" :href="lectures[item.topicId].pptLink" target="_blank">
                <!-- <img src="./assets/ppt_icon.svg"> -->
              </a>
              <a v-if="Number(lectures[item.topicId].pptStatus)===1">
                <img src="./assets/ppt_forbidden.svg">
              </a>
              <a class="iconfont icon-live_icon" v-if="lectures[item.topicId].hasLive" href="https://time.geekbang.org/">
                <!-- <img src="./assets/live_icon.svg"> -->
              </a>
              <a class="iconfont icon-ppt_inreview" v-if="Number(lectures[item.topicId].pptStatus)===2">
                <!-- <img src="./assets/ppt_inreview.svg"> -->
              </a>
            </p>
          </template>
          <template v-else>
            <p class="postion">
              <span>/</span>
            </p>
          </template>
        </td>
      </tr>
    </tbody>
    </template>

    <!-- pm -->
    <template v-if="config.type !== 'training'">
    <!-- 主题 -->
    <tr class="title topic" v-if="config.type !== 'training'">
      <td rowspan="2">下午</td>
      <td
        v-for="(item,idx) in config.table.pmTopic"
        :key="idx"
        v-if="topics[item.topicId]"
        :colspan="item.width"
        :class="Number(topics[item.topicId].type) === 2 ? 'manufacturers-build':'' ">
        <router-link :to="'/track/' + item.topicId" class="topic-name-link topic-name">
          {{ topics[item.topicId].topic }} <br/>
        </router-link>
        <template v-if="topics[item.topicId].producerIds[0]">
          <router-link
            v-if="topics[item.topicId].producerIds[0] && speakers[topics[item.topicId].producerIds[0]]"
            :to="'/track/' + item.topicId"
            class="producter-link">
            <span v-for="(speaker, key) in topics[item.topicId].speakers" :key="key">{{ speaker.name }}</span>
            出品
            <!--{{ speakers[topics[item.topicId].producerIds[0]].name }} 出品-->
          </router-link>
        </template>
      </td>
    </tr>
    <!-- 地址 -->
    <tr class="address">
      <td
        v-for="(item, idx) in config.table.pmTopic"
        :key="idx"
        v-if="topics[item.topicId]"
        :colspan="item.width"
        :class="Number(topics[item.topicId].type) === 2 ? 'manufacturers-build':'' ">
        <p v-if="topics[item.topicId].address">
          {{ topics[item.topicId].address }}
        </p>
      </td>
    </tr>
    <!-- 议题 -->
    <tbody
      v-for='(lectures, time) in schedules'
      :key="time"
      v-if="checkTime(time, config.date, 'pm')"
      class="subject">
      <tr>
        <td class="time-td">{{ getTimeV2(lectures.beginTime)}}-{{ getTimeV2(lectures.endTime)}}</td>
        <td
          v-for='(item, idx) in config.table.pmTopic'
          :key="idx"
          :colspan="item.width"
          :class="{
            overseas:lectures[item.topicId] && lectures[item.topicId].isOversea,
            'no-presentation': !lectures[item.topicId]
          }">
          <template v-if="lectures[item.topicId]">
            <router-link :to="'/presentation/' + lectures[item.topicId]['id']">
              <!-- <span class="overseas" v-if="lectures[item.topicId].isOversea">【海外】</span> -->
              {{ lectures[item.topicId]['title'] }}
            </router-link>
          <template v-if="lectures[item.topicId].speakers">
            <p class="postion" v-for="(speaker, idx) in lectures[item.topicId].speakers" :key="idx">
              {{ speaker.name }}
              <span>{{ speaker.company }} /</span>
              <span v-html="speaker.position"></span>
            </p>
          </template>
            <!-- 图标 -->
            <img class="overseas-img" src="./assets/overseas.svg" v-if="lectures[item.topicId].isOversea">
            <p class="sch-icons">
              <a class="iconfont icon-video" v-if="lectures[item.topicId].videoLink" :href="lectures[item.topicId].videoLink" target="_blank">
                <!-- <img src="./assets/video_icon.svg"> -->
              </a>
              <a v-if="!lectures[item.topicId].videoStatus">
                <img src="./assets/video_forbidden.svg">
              </a>
              <a class="iconfont icon-ppt" v-if="Number(lectures[item.topicId].pptStatus)===0&&lectures[item.topicId].pptLink" :href="lectures[item.topicId].pptLink" target="_blank">
                <!-- <img src="./assets/ppt_icon.svg"> -->
              </a>
              <a v-if="Number(lectures[item.topicId].pptStatus)===1">
                <img src="./assets/ppt_forbidden.svg">
              </a>
              <a class="iconfont icon-live_icon" v-if="lectures[item.topicId].hasLive" href="https://time.geekbang.org/">
                <!-- <img src="./assets/live_icon.svg"> -->
              </a>
              <a class="iconfont icon-ppt_inreview" v-if="Number(lectures[item.topicId].pptStatus)===2">
                <!-- <img src="./assets/ppt_inreview.svg"> -->
              </a>
            </p>
          </template>
          <template v-else>
            <p class="postion">
              <span>/</span>
            </p>
          </template>
        </td>
      </tr>
    </tbody>
    </template>

    <!-- after -->
    <tbody v-if="config.type !== 'training'">
      <tr
        v-for='(sch, time) in schsCommon'
        :key="time"
        v-if="checkTime(time, config.date, 'pm')">
        <td class="time-td">{{ getTimeV2(sch.beginTime)}}-{{ getTimeV2(sch.endTime)}}</td>
        <td :colspan="config.table.tableWidth" v-html="sch.title"></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment'

export default {
  props: [
    'data', // 日程
    'config', // 日程配置信息
    'topics', // 专题
    'lectures', // 议题
    'speakers' // 讲师
  ],
  data: function () {
    return {
      schedules: {},
      schsCommon: {},
      schsTraining: {}
    }
  },
  created () {
    this.data.forEach(schedule => {
      let time = moment(schedule.beginTime).unix()

      if (schedule.type === 'common') {
        this.schsCommon[time] = schedule
      }
      if (schedule.type === 'lecture') {
        let lecture = this.lectures[schedule.lectureId]
        if (!lecture) return
        if (!lecture.topicId) return
        if (!this.schedules[time]) this.schedules[time] = {}
        this.schedules[time][lecture.topicId] = lecture
        this.schedules[time].beginTime = lecture.beginTime
        this.schedules[time].endTime = lecture.endTime
        // training
        if (this.topics[lecture.topicId] && Number(this.topics[lecture.topicId].typeid) === 3) {
          if (!this.schsTraining[time]) this.schsTraining[time] = {}
          this.schsTraining[time][lecture.topicId] = lecture
          this.schsTraining[time].beginTime = lecture.beginTime
          this.schsTraining[time].endTime = lecture.endTime
        }
      }
    })
  },
  mounted: function () {
  },
  methods: {
    /**
     * 判断时间是否在某天的上午或下午
     *
     * @param time 时间
     * @param date 天
     * @param bucket ‘am’, 'pm'
     */
    checkTime (time, date, bucket) {
      time = moment(time * 1000)
      let dateBegin = moment(date).utcOffset('+08:00').startOf('day')
      let dateMiddle = dateBegin.clone().add(12, 'h')
      let dateEnd = dateBegin.clone().add(24, 'h')
      if (bucket === 'am') {
        return time.isAfter(dateBegin) && !time.isAfter(dateMiddle)
      } else if (bucket === 'pm') {
        return time.isAfter(dateMiddle) && !time.isAfter(dateEnd)
      } else {
        return false
      }
    },
    // @param time: utc-format
    getTimeV2 (time) {
      return moment(time).utcOffset('+08:00').format('HH:mm')
    },
    getTimeTraining (timeBegin, timeEnd) {
      timeBegin = moment(timeBegin)
      timeEnd = moment(timeEnd)
      let day = timeBegin.utcOffset('+08:00').format('MM月DD日')
      let dateBegin = timeBegin.clone().utcOffset('+08:00').startOf('day')
      let dateMiddle = dateBegin.clone().add(12, 'h')
      let zone
      if (timeEnd.isBefore(dateMiddle) || timeEnd.isSame(dateMiddle)) {
        zone = '上午'
      } else if (timeBegin.isAfter(dateMiddle)) {
        zone = '下午'
      } else {
        zone = '全天'
      }
      return {
        day,
        zone
      }
    },
    // 修改时间格式，补齐位数
    formatTime: function (time) {
      let hour = Number(time.split(':')[0])
      let minutes = Number(time.split(':')[1])
      return (hour >= 10 ? hour : '0' + hour) + ':' + (minutes >= 10 ? minutes : '0' + minutes)
    }
  }
}
</script>

<style lang='scss' scoped>

.sch-icons{
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    // vertical-align: middle;
  }
  .icon-ppt , .icon-video, .icon-live_icon, .icon-ppt_inreview {
    color: var(--primary-color);
    font-weight: 400;
  }
  .icon-ppt {
    font-size: 32px;
  }
  .icon-video {
    font-size: 30px;
  }
  .icon-live_icon {
    font-size: 35px;
  }
  .icon-ppt_inreview {
    font-size: 38px;
  }
}
table {
  table-layout: fixed;
  width: 100%;
}
tr.title {
  background: var(--primary-color);
  color: #FFF;
}
tr.address {
  background: var(--primary-color);
  color: #FFF;
}

table tr td {
  padding: 10px;
  border: #CCC solid 1px;
  line-height: 1.71429;
  text-align: center;
  vertical-align: middle;
  position: relative;
}
tbody tr td:nth-child(2n) {
  background-color: #fafafa;
}
tbody tr td p {
  line-height: 1.51429;
  margin: 0 0 10px;
  font-size: 14px;
}
tbody tr td p a {
  color: #337ab7;
  text-decoration: none;
  list-style: none;
  font-size: 14px;
  font-weight: 600;
}
tbody tr td .postion span {
  color: #9c9e99;
}
tbody tr td .overseas-img {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
}
tbody tr td span.overseas {
  /*color: #ff5a05*/
  color: var(--primary-color)
}
tr.title td:first-child {
  width: 90px;
  background: var(--primary-color);
  border: #CCC solid 1px;
}
td.time-td {
  color: #9c9e99;
}
.topic td p {
  font-size: 16px;
  line-height: 1.51429;
}
.topic td .topic-name {
  font-weight: 600;
}
.topic td .topic-name-link {
  text-decoration: none;
  list-style: none;
  color: #FFF;
}
.topic td .topic-name-link:hover {
  opacity: 0.6;
}
.topic td .producter {
  opacity: 0.7;
  font-size: 14px;
  margin-top: 10px;
  color: #bccfe4;
}
.topic td .producter-link {
  opacity: 0.7;
  font-size: 14px;
  margin-top: 10px;
  text-decoration: none;
  margin: 0;
  padding: 0;
  list-style: none;
  color: #bccfe4;
}
.topic td .producter-link:hover {
  color: white;
}

.topic td .producter-link span{
  display: inline-block;
  padding: 3px;
}

td.manufacturers-build {
  background-color: #448aca;
}
.manufacturers-build-title {
  font-size: 9px;
  color: white;
}
.zebra {
  background: #FAFAFA;
}
// .overseas {
  /*background: #F6F6F6;*/
// }
// .no-presentation {
  /*background-image: url('./assets/bg-none.png')*/
// }
</style>
